export default __webpack_public_path__ + "img/jJhaICvG.16fe2e22.svg";